{
  "title": "Indicative repayment plan",
  "disclaimer": "This repayment plan is indicative, for informational purposes only and could be inaccurate. Actual costs and payments may vary based on the final terms from the lender.",
  "exportToExcel": "Export to Excel",
  "exporting": "Exporting…",
  "tabs": {
    "table": "Table",
    "graph": "Graph"
  },
  "month": "Month",
  "payment": "Payment",
  "interest": "Interest",
  "principal": "Principal",
  "fees": "Fees",
  "remainingBalance": "Remaining balance",
  "total": "Total",
  "setupFee": "Setup fee (one-time)",
  "totalRepaid": "Total to repay",
  "totalCostOfCredit": "Total cost of credit",
  "loading": "Loading…",
  "totalsTitle": "Totals",
  "slider": {
    "label": "Repay over",
    "originalTerm": "Original term"
  },
  "savings": {
    "title": "Potential savings from early repayment",
    "interestSaved": "Interest saved",
    "feesSaved": "Fees saved",
    "grossSaved": "Total savings (gross)",
    "earlyRepaymentFee": "Early-repayment fee",
    "repaidEarlier": "Repaid {{duration}} earlier — indicative estimate that assumes the full balance is settled at month-end."
  },
  "tooltips": {
    "setupFee": "A one-time fee charged when the loan is set up. Shown on month 0.",
    "totalCostOfCredit": "Everything the loan costs on top of the amount borrowed (all interest plus all fees).",
    "totalRepaid": "The full amount repaid over the term: the amount borrowed plus the total cost of credit.",
    "interestSaved": "Interest you avoid by repaying early instead of running the full term.",
    "feesSaved": "Recurring fees (e.g. invoicing and direct debit) you avoid on the months you skip.",
    "grossSaved": "Interest and fees saved combined, before any early-repayment fee is subtracted.",
    "earlyRepaymentFee": "A fee the lender may charge for settling the loan before the end of the term."
  }
}
